import { Environment } from '@standardnotes/models';
/* istanbul ignore file */
export function isMobileDevice(x) {
    return x.environment === Environment.Mobile;
}
